import 'core-js/fn/promise';
import 'core-js/fn/object/assign';
import 'core-js/fn/string/starts-with';
import 'core-js/fn/array/is-array';



/** WEBPACK FOOTER **
 ** ./shim.js
 **/